module.exports = __webpack_public_path__ + "img/call-answer.1b4580c2.png";